import {createContext, type ReactNode, useContext} from "react";

import {IAmplitudeItemListContext} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";

export type AmplitudePageLocation = "property_page" | "investment_page";

interface IOfferPageAmplitudeItemListTrackingContext {
    itemListContext: IAmplitudeItemListContext | null;
    isResolved: boolean;
    pageLocation: AmplitudePageLocation;
}

interface IOfferPageAmplitudeItemListTrackingContextProviderProps extends IOfferPageAmplitudeItemListTrackingContext {
    children: ReactNode;
}

const OfferPageAmplitudeItemListTrackingContext = createContext<IOfferPageAmplitudeItemListTrackingContext>({
    itemListContext: null,
    isResolved: false,
    pageLocation: "investment_page"
});

export const OfferPageAmplitudeItemListTrackingContextProvider = (props: IOfferPageAmplitudeItemListTrackingContextProviderProps) => {
    const {children, itemListContext, isResolved, pageLocation} = props;

    return (
        <OfferPageAmplitudeItemListTrackingContext.Provider value={{itemListContext, isResolved, pageLocation}}>
            {children}
        </OfferPageAmplitudeItemListTrackingContext.Provider>
    );
};

export const useOfferPageAmplitudeItemListTrackingContext = () => useContext(OfferPageAmplitudeItemListTrackingContext);
import {createContext, type ReactNode, useContext} from "react";

import {IAmplitudeItemListContext} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";

export type AmplitudePageLocation = "property_page" | "investment_page";

interface IOfferPageAmplitudeItemListTrackingContext {
    itemListContext: IAmplitudeItemListContext | null;
    isResolved: boolean;
    pageLocation: AmplitudePageLocation;
}

interface IOfferPageAmplitudeItemListTrackingContextProviderProps extends IOfferPageAmplitudeItemListTrackingContext {
    children: ReactNode;
}

const OfferPageAmplitudeItemListTrackingContext = createContext<IOfferPageAmplitudeItemListTrackingContext>({
    itemListContext: null,
    isResolved: false,
    pageLocation: "investment_page"
});

export const OfferPageAmplitudeItemListTrackingContextProvider = (props: IOfferPageAmplitudeItemListTrackingContextProviderProps) => {
    const {children, itemListContext, isResolved, pageLocation} = props;

    return (
        <OfferPageAmplitudeItemListTrackingContext.Provider value={{itemListContext, isResolved, pageLocation}}>
            {children}
        </OfferPageAmplitudeItemListTrackingContext.Provider>
    );
};

export const useOfferPageAmplitudeItemListTrackingContext = () => useContext(OfferPageAmplitudeItemListTrackingContext);
